import { render, staticRenderFns } from "./Lan.vue?vue&type=template&id=2d839dde&"
import script from "./Lan.vue?vue&type=script&lang=js&"
export * from "./Lan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports